<template>
  <v-row>
    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Indicadores:</h3>

            <v-switch
              v-model="enable_indicators_section_landing"
              label="Habilitar indicadores"
            ></v-switch>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-divider></v-divider>
            </v-row>
          </v-col>

          <v-col cols="12">
            <h3>Título de la Sección:</h3>
            <v-text-field
              v-model="title_indicators"
              :disabled="!enable_indicators_section_landing"
              :counter="100"
              :maxLength="100"
              class="mt-4"
              label="Título para esta sección"
              outlined
            ></v-text-field>
          </v-col>

          <v-row 
            v-if="!refresh_indicators"
            class="d-flex align-center justify-space-around mt-4 pa-4">
            <v-col
              v-for="(item, index)  in indicators"
              :key="index"
              class="item tall d-flex justify-center mb-2">

              <v-sheet
                v-if="!item.delete"
                
                outlined
                width="240"
                height="260"
                class="pa-3 transparent-sheet">
                <v-row>
                  <v-col cols="12">
                    <v-img
                      :lazy-src="item.url_image"
                      height="90"
                      width="280"
                      contain
                      :src="item.url_image"
                    ></v-img>
                  </v-col>

                  <v-col 
                    cols="12" 
                    class="d-flex align-center justify-center mt-1">
                    <h2 
                      style="font-size:42px;"
                      class="text-center font-weight-light">
                      +{{ item.number }}
                    </h2>
                  </v-col>
                  
                  <v-col 
                    cols="12" 
                    style="height:60px;"
                    class="d-flex align-center justify-center">
                    <p class="text-center title-1 font-weight-light">{{ item.title }}</p>
                  </v-col>

                  <v-col 
                    cols="12" 
                    style="height:50px;"
                    class="d-flex align-center justify-center">
                    <!-- <v-btn
                      class="mb-8 mr-4"
                      fab
                      dark
                      x-small
                      color="warning"
                      @click="editIndicator(index)"
                    >
                      <v-icon dark>
                        mdi-pencil-outline
                      </v-icon>
                    </v-btn> -->
                    
                    <v-btn
                      class="mb-8"
                      fab
                      x-small
                      color="error"
                      :dark="enable_indicators_section_landing"
                      :disabled="!enable_indicators_section_landing"
                      @click="deleteIndicator(index)"
                    >
                      <v-icon dark>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </v-row>

          <v-col cols="12" class="d-flex align-center justify-center mt-8 mb-8">
            <v-btn
              color="primary"
              :disabled="!enable_indicators_section_landing"
              @click="add_indicator_dialog=true">
              Agregar Indicador
            </v-btn>
          </v-col>
          
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'customizationLanding' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateIndicatorsLanding()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="add_indicator_dialog"
      width="480">
      <v-card>
        <v-card-title class="text-h6">
          Indicador
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col
              cols="12">

              <v-file-input
                outlined
                v-if="!image"
                v-model="image"
                @change="onIconChange()"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Icono indicador"
                :messages="['Para una mejor visualización, usar un imagen cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
              ></v-file-input>

              <v-card
                v-if="image">
                <v-img
                  contain
                  :src="url_image"
                  class="grey lighten-2"
                  height="100px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteIconImage()">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card> 

              <v-text-field
                class="mt-4"
                v-model="title"
                :counter="100"
                :maxLength="100"
                outlined
                label="Título indicador"
              ></v-text-field>

              <v-text-field
                v-model="number"
                :counter="100"
                :maxLength="100"
                outlined
                label="Valor del indicador"
                type="text"
                @keypress="isNumber"
              ></v-text-field>

            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="add_indicator_dialog=!add_indicator_dialog"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="addIndicator()"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="edit_indicator_dialog"
      width="480">
      <v-card>
        <v-card-title class="text-h6">
          Indicador
        </v-card-title>

        <v-card-text class="pa-8">
          <v-row>
            <v-col
              cols="12">

              <v-file-input
                outlined
                v-if="!image"
                v-model="image"
                @change="onIconChange()"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                label="Icono indicador"
                :messages="['Para una mejor visualización, usar un imagen cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
              ></v-file-input>

              <v-card
                v-if="image">
                <v-img
                  contain
                  :src="url_image"
                  class="grey lighten-2"
                  height="100px"
                >
                </v-img>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon color="black" @click="deleteIconImage()">mdi-delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card> 

              <v-text-field
                class="mt-4"
                v-model="title"
                :counter="100"
                :maxLength="100"
                outlined
                label="Título indicador"
              ></v-text-field>

              <v-text-field
                v-model="number"
                :counter="100"
                :maxLength="100"
                outlined
                label="Valor del indicador"
              ></v-text-field>

            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="edit_indicator_dialog=!edit_indicator_dialog"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="updateIndicator()"
          >
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationIndicatorsSection',
    data: () => ({
      loading:true,
      loading_update: false,
      refresh_indicators:false,
      landing: [],
      enable_indicators_section_landing:false,
      title_indicators:'',
      
      showFileInput: true,
      id_indicator: null,
      image: null,
      url_image: null,
      title:'',
      number:'',

      indicators: [],
      indicators_delete: [],

      add_indicator_dialog: false,
      edit_indicator_dialog: false,

      error:false,
      errors:[]
    }),
    methods:{
      isNumber(event) {
        const charCode = event.which ? event.which : event.keyCode;
        // Allow only numbers (charCode 48-57)
        if (charCode < 48 || charCode > 57) {
          event.preventDefault();
        }
      },

      async getCustomization(){
        await axios.get('admin/landing').then(response =>{
          this.landing = response.data.data.landing
          this.enable_indicators_section_landing = (this.landing.enable_indicators_section_landing)?true:false
          this.title_indicators = (this.landing.title_indicators)?this.landing.title_indicators:''
          this.indicators = this.landing.indicators

          this.indicators.forEach(element => {
            element.url_image = APP_URL + element.image
            element.new = false
            element.edit = false
            element.delete = false
          });

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateIndicatorsLanding() {
        this.loading_update = true;
        let formData = new FormData();
        
        formData.append('enable_indicators_section_landing', (this.enable_indicators_section_landing) ? 1 : 0);
        if (this.title_indicators != null) {
            formData.append('title_indicators', this.title_indicators);
        }
        // Append each image file separately
        this.indicators.forEach((indicator, index) => {
            formData.append(`indicators[${index}][id]`, indicator.id);
            formData.append(`indicators[${index}][title]`, indicator.title);
            formData.append(`indicators[${index}][number]`, indicator.number);
            formData.append(`indicators[${index}][new]`, indicator.new);
            formData.append(`indicators[${index}][edit]`, indicator.edit);
            formData.append(`indicators[${index}][delete]`, indicator.delete);
            if (indicator.image && indicator.image instanceof File) {
                formData.append(`indicators[${index}][image]`, indicator.image);
            }
        });
        
        formData.append('indicators_delete', JSON.stringify(this.indicators_delete));

        try {
            await axios({
                method: 'post',
                url: 'admin/landing/indicators-section',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(() => {
                this.loading_btn = false;
                this.$router.push({ name: 'customizationLanding' });
            });
        } catch (error) {
            console.log('Response: ');
            console.error(error.response.data);
        }
      },

      addIndicator() {
        const newIndicator = {
          image: this.image,
          url_image: this.url_image,
          title: this.title,
          number: this.number,
          new: true,
          edit: false,
          delete: false,
        }
        this.indicators.push(newIndicator)
        this.add_indicator_dialog = false
        this.image = ''
        this.url_image = ''
        this.title = ''
        this.number = ''
      },

      editIndicator(index){
        this.title = this.indicators[index].title
        this.number = this.indicators[index].number
        this.url_image = this.indicators[index].url_image
        this.image = this.indicators[index].image

        this.edit_indicator_dialog = true
      },

      updateIndicator(index) {
        const newIndicator = {
          image: this.image,
          url_image: this.url_image,
          title: this.title,
          number: this.number
        }

        console.log(index)

        this.indicators.push(newIndicator)

        this.add_indicator_dialog = false

        this.image = ''
        this.url_image = ''
        this.title = ''
        this.number = ''
      },

      deleteIndicator(index){
        this.indicators_delete.push(this.indicators[index].id)
        this.refresh_indicators = true
        this.indicators[index].delete = true
        this.refresh_indicators = false

        this.indicators.splice(index, 1);

      },

      //-------Icon Indicator-----------
      onIconChange() {
        this.url_image = URL.createObjectURL(this.image);
      },

      deleteIconImage(){
        this.image=null
        this.url_image=null
      }
    },

    created(){
      this.getCustomization()
    },
  }
</script>
<style scoped>

.item {
  flex: 0 1 auto;
  background: none;
}

.tall {
  width: 230px;
}

.transparent-sheet {
  background-color: transparent !important;
}
</style>